export default __webpack_public_path__ + "static/find.gif";